import { equalsIgnoreCase } from '@cascade/core/utils';
import { createQueryKey } from '#providers/query/index.ts';
import type { TDependentsResponse } from './Dependents.types.ts';

export const getDependentsQueryKey = (projectId?: string) =>
  createQueryKey('dependents', 'listDependents', {
    project_id: projectId ?? '',
  });

export const hasDependentEmail = (emails: string[], email: string): boolean =>
  emails.some((candidate) => equalsIgnoreCase(candidate, email.trim()));

export const requireSuccess = <TResponse extends TDependentsResponse>(
  response: TResponse,
): TResponse => {
  if (!response.success) {
    throw new Error(response.message ?? 'The request was refused');
  }

  return response;
};
